import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'glxy-page-nav, [glxyPageNav]',
  standalone: false,
})
export class PageNavDirective {
  @HostBinding('class') class = 'glxy-page-nav';
}
